export default {
    label_task:{
        en:"Type Color",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Type Color",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Type Color",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Type Color",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_value:{
        en:"Value",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_color:{
        en:"Color",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}